<!--
  ~  ZAITEC CONFIDENTIAL
  ~  __________________
  ~
  ~ [2019] - [2025] zaiTEC Logixs Ltd
  ~ All Rights Reserved.
  ~
  ~ NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
  ~  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
  ~  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
  ~  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
  -->

<div class="not-found-container">
  <h1 class="not-found-title">404 - Page Not Found</h1>
  <p class="not-found-message">Oops! The page you're looking for doesn't exist.</p>
  <button data-testid="not-found-home-button" class="not-found-btn" (click)="goHome()">Go to Home Page</button>
</div>
